export const colors = {
    blue: {
        0: '#3b5d78',
        1: '#3f6788',
        2: '#3b617d',
    },
    grey: {
        0: '#6f7980',
        1: '#a8b5bd',
        2: '#DCDFE2',
    },
    white: {
        0: '#FFF',
    },
};
